import "@fortawesome/fontawesome-free/css/all.css";
import "@/sass/main.scss";
import colors from "vuetify/lib/util/colors";

import { createVuetify } from "vuetify";
import { fr } from "vuetify/locale";
import {
    VAutocomplete,
    VBtn,
    VCombobox,
    VSelect,
    VTextField,
    VChip,
    VTextarea,
    VToolbar,
    VTabs,
    VSnackbar,
} from "vuetify/lib/components/index.mjs";
import { VTreeview, VTreeviewItem } from "vuetify/labs/VTreeview";
import { VCalendar } from "vuetify/labs/VCalendar";
import { aliases } from "./icon-sets";

import { OssTextField } from "@/components/ui/oss-text-field";
import { OssDatePicker, OssDatePickerFilled } from "@/components/ui/oss-date-picker";

import OssDialog from "@/views/ossComponents/ossDialog.vue";
import OssConfirm from "@/views/ossComponents/ossConfirm.vue";
import OssCard from "@/views/ossComponents/ossCard.vue";
import OssDataTable from "@/views/ossComponents/ossDataTable.vue";
import OssDateRangePicker from "@/views/ossComponents/ossDateRangePicker.vue";
import OssDateRangePickerFilled from "@/views/ossComponents/ossDateRangePickerFilled.vue";
import VDatePickerWrapper from "@/components/ui/VDatePickerWrapper.vue";
import OssTagsSelector from "@/views/ossComponents/ossTagsSelector.vue";
import * as components from "vuetify/components";

export const vuetify = createVuetify({
    styles: {
        configFile: "src/sass/main.scss",
    },
    locale: {
        locale: "fr",
        fallback: "fr",
        messages: { fr },
    },
    date: {
        locale: {
            fr: "fr",
        },
    },
    aliases: {
        // OssDatePicker: OssDatePicker,
        // OssDatePickerFilled: OssDatePickerFilled,
        OssDialog: OssDialog,
        OssConfirm: OssConfirm,
        OssTextField: OssTextField,
        OssTextFieldFilled: OssTextField,
        OssCard: OssCard,
        OssDataTable: OssDataTable,
        // VBtnCircle: VBtn,
        VBtnPrimary: VBtn,
        VBtnTernary: VBtn,
        VBtnIcon: VBtn,
        VBtnTgl: VBtn,
        VBtnAdd: VBtn,
        VBtnAddIcon: VBtn,
        VBtnRemoveIcon: VBtn,
        VBtnCreate: VBtn,
        VBtnReset: VBtn,
        VBtnResetIcon: VBtn,
        VBtnEdit: VBtn,
        VBtnEditIcon: VBtn,
        VBtnWarning: VBtn,
        VBtnBack: VBtn,
        VBtnPrev: VBtn,
        VBtnNext: VBtn,
        VBtnTrash: VBtn,
        VTextFieldFilled: VTextField,
        VSnackbar: VSnackbar,
        VComboboxFilled: VCombobox,
        VTextareaFilled: VTextarea,
        VSelectFilled: VSelect,
        VAutocompleteFilled: VAutocomplete,
        VChipTag: VChip,
        VTabsFilled: VTabs,
        VToolbarFilled: VToolbar,
        VTreeview: VTreeview,
        VTreeviewItem: VTreeviewItem,
        VCalendar: VCalendar,
        OssDatePicker: OssDatePicker,
        OssDatePickerFilled: OssDatePickerFilled,
        OssDateRangePicker: OssDateRangePicker,
        OssDateRangePickerFilled: OssDateRangePickerFilled,
        VDatePickerWrapper: VDatePickerWrapper,
        OssTagsSelector: OssTagsSelector,
        OssTagsSelectorFilled: OssTagsSelector,
    },
    icons: {
        defaultSet: "mdi",
        aliases: {
            calendar: "far fa-calendar",
            invoice: "fas fa-file-invoice",
            "pdf-file": "fas fa-file-pdf",
            ...aliases,
        },
        sets: {
            mdi: {
                component: "VIcon",
            },
            svg: {
                component: "VIcon",
            },
        },
    },
    theme: {
        defaultTheme: "bobbee",
        themes: {
            bobbee: {
                dark: false,
                colors: {
                    primary: "#F9B12A",
                    secondary: "#262626",
                    ternary: "#64AADC",
                    "primary-foreground": "#FFFFFF",
                    background: "#F5F5F5",
                    "on-primary": "#FFFFFF",
                    filled: "#ECECEC",
                    gradient: "#8693a0",

                    green: "#5FC9B8",
                    red: colors.red.darken1,
                    orange: colors.orange.darken1,
                    blue: colors.blue.darken1,
                    blueGrey: colors.blueGrey.darken1,

                    error: "#EC6D56",
                    blue_custom: "#e9f1f9",
                    yellow_custom: "#F00",
                    dark_grey: "#EDEDED",
                    light_grey: colors.grey.lighten1,

                    tagFixeVariable: "#faeed5",
                    tagGenericPurchase: "#d3e8e2",
                    tagGenericSales: "#ffd4d4",
                    tagFolder: "#e8d6cf",
                    tagFree: "#d1e5f9",
                    tagSubAccountableAccount: "#64AADC",
                    tagLog: "#e1d5fa",

                    new_red: "#EC6D56",
                    calendar_red: "#fc5c65",
                    calendar_green: "#20bf6b",
                    calendar_yellow: "#F9B12A",

                    magic: "#64AADC",
                },
            },
        },
    },
    defaults: {
        VBtn: {
            color: "primary",
            rounded: "pill",
            elevation: 0,
            variant: "flat",
        },
        VBtnPrimary: {
            color: "gradient",
            rounded: "xl",
            elevation: 0,
        },
        VBtnTernary: {
            color: "ternary",
            rounded: "pill",
            elevation: 0,
            variant: "tonal",
            size: "x-small",
        },
        VBtnIcon: {
            variant: "plain",
            color: "secondary",
            elevation: 0,
        },
        VBtnPrev: {
            variant: "plain",
            color: "secondary",
            elevation: 0,
            icon: "$navigate_before",
        },
        VBtnNext: {
            variant: "plain",
            color: "secondary",
            elevation: 0,
            icon: "$navigate_next",
        },
        VBtnTrash: {
            variant: "plain",
            color: "secondary",
            elevation: 0,
            icon: "$oss-trash",
        },
        VProgressLinear: {
            color: "primary",
        },
        VBtnToggle: {
            density: "compact",
            color: "primary",
            variant: "outlined",
            divided: true,
            rounded: "lg",
            // border: "xs",
            VBtn: {
                // variant: "outlined",
                // size: "small",
                rounded: null,
                variant: "elevated",
            },
        },
        VBtnAdd: {
            color: "primary",
            rounded: "pill",
            appendIcon: "$add",
            text: "Ajouter",
            elevation: 0,
            variant: "flat",
        },
        VBtnAddIcon: {
            color: "primary",
            rounded: "pill",
            size: "small",
            icon: "$add",
            elevation: 0,
            variant: "flat",
        },
        VBtnRemoveIcon: {
            color: "primary",
            rounded: "pill",
            size: "small",
            icon: "$remove",
            elevation: 0,
            variant: "flat",
        },
        VBtnCreate: {
            color: "primary",
            rounded: "pill",
            appendIcon: "$add",
            text: "Créer",
            elevation: 0,
            variant: "flat",
        },
        VBtnReset: {
            color: "primary",
            rounded: "pill",
            appendIcon: "$fa-sync",
            text: "Réinitialiser",
            elevation: 0,
            variant: "flat",
        },
        VBtnResetIcon: {
            color: "primary",
            rounded: "pill",
            size: "small",
            icon: "$fa-sync",
            elevation: 0,
            variant: "flat",
        },
        VBtnEdit: {
            color: "primary",
            rounded: "pill",
            appendIcon: "$oss-edit",
            text: "Modifier",
            elevation: 0,
            variant: "flat",
        },
        VBtnEditIcon: {
            color: "primary",
            rounded: "pill",
            size: "small",
            icon: "$oss-edit",
            elevation: 0,
            variant: "flat",
        },
        VBtnWarning: {
            color: "primary",
            rounded: "pill",
            size: "small",
            icon: "$oss-warning",
            elevation: 0,
            variant: "flat",
        },
        VBtnBack: {
            color: "primary",
            elevation: 0,
            variant: "flat",
            icon: "$fa-chevron-left",
            style: "height: 36px; width: 36px;",
        },
        VOtpInput: {
            variant: "solo",
            rounded: "xl",
            density: "compact",
            bgColor: "primary-foreground",
            hideDetails: "auto",
        },
        VTextField: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            bgColor: "primary-foreground",
            hideDetails: "auto",
        },
        VTextFieldFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            bgColor: "filled",
            hideDetails: "auto",
        },
        VTextarea: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            bgColor: "primary-foreground",
            hideDetails: "auto",
        },
        VTextareaFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            bgColor: "filled",
            hideDetails: "auto",
        },
        VSelect: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            bgColor: "primary-foreground",
            hideDetails: "auto",
            noDataText: "Aucune donnée disponible",
        },
        VSelectFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            bgColor: "filled",
            hideDetails: "auto",
            noDataText: "Aucune donnée disponible",
        },
        VCombobox: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            bgColor: "primary-foreground",
            hideDetails: "auto",
        },
        VComboboxFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            size: "small",
            bgColor: "filled",
            hideDetails: "auto",
        },
        VAutocomplete: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            bgColor: "primary-foreground",
            hideDetails: "auto",
            density: "compact",
        },
        VAutocompleteFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            bgColor: "filled",
            hideDetails: "auto",
            density: "compact",
        },
        VSlider: {
            color: "primary",
            showTicks: "always",
            tickSize: 5,
            thumbColor: "primary",
            thumbSize: 15,
            trackColor: "grey",
            step: 1,
            elevation: 0,
        },
        VRangeSlider: {
            color: "primary",
            showTicks: "always",
            tickSize: 5,
            thumbColor: "primary",
            thumbSize: 15,
            trackColor: "grey",
            step: 1,
            elevation: 0,
        },

        VCard: {
            elevation: 0,
            rounded: "xl",
        },
        VChipTag: {
            label: true,
            size: "x-small",
            ripple: "false",
            // color: colors.grey.darken2
        },
        VDatePicker: {
            "first-day-of-week": 1,
        },
        VDatePickerWrapper: {
            "first-day-of-week": 1,
            rounded: "xl",
        },
        VSwitch: {
            color: "primary",
            density: "compact",
            flat: true,
            hideDetails: "auto",
        },
        OssDatePicker: {
            bgColor: "primary-foreground",
        },
        VCheckbox: {
            color: "primary",
            hideDetails: "auto",
        },
        OssTextField: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            bgColor: "primary-foreground",
            hideDetails: "auto",
            density: "compact",
        },
        OssTextFieldFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            bgColor: "filled",
            hideDetails: "auto",
            density: "compact",
        },
        VTabs: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            color: "secondary",
            bgColor: "primary-foreground",
            hideDetails: "auto",
            mandatory: true,
        },
        VTab: {
            color: "secondary",
        },
        VTabsFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            bgColor: "filled",
            hideDetails: "auto",
            mandatory: true,
            color: "secondary",
        },
        VToolbar: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            color: "primary-foreground",
            hideDetails: "auto",
        },
        VToolbarFilled: {
            variant: "solo",
            flat: true,
            rounded: "xl",
            density: "compact",
            color: "filled",
            hideDetails: "auto",
        },
        VCardActions: {
            VBtn: {
                variant: "flat",
            },
        },
        VDataTable: {
            noDataText: "Aucune donnée disponible",
            itemsPerPageText: "Lignes par page : ",
        },
        VDataTableServer: {
            noDataText: "Aucune donnée disponible",
            itemsPerPageText: "Lignes par page : ",
            loadingText: "Chargement des données",
        },
        VDataTableVirtual: {
            noDataText: "Aucune donnée disponible",
            itemsPerPageText: "Lignes par page : ",
        },
        OssTagsSelectorFilled: {
            variant: "filled",
        },
    },
    components,
});
